import { render, staticRenderFns } from "./Eraser.vue?vue&type=template&id=b5cb3c06&scoped=true&"
import script from "./Eraser.vue?vue&type=script&lang=js&"
export * from "./Eraser.vue?vue&type=script&lang=js&"
import style0 from "./Eraser.vue?vue&type=style&index=0&id=b5cb3c06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb3c06",
  null
  
)

export default component.exports